import {
  MULTIPLE_NOTES_ADD_APPLICATION_ID,
  MULTIPLE_NOTES_CLEAR_APPLICATION_IDS,
  MULTIPLE_NOTES_HIDE,
  MULTIPLE_NOTES_REMOVE_APPLICATION_ID,
  MULTIPLE_NOTES_SET_APPLICATION_IDS,
  MULTIPLE_NOTES_SET_NOTE,
  MULTIPLE_NOTES_SET_TEMPLATE_ID,
  MULTIPLE_NOTES_SET_VISIBLE,
  MULTIPLE_NOTES_SHOW,
  MULTIPLE_NOTES_UNSET_NOTE,
  MULTIPLE_NOTES_UNSET_TEMPLATE_ID,
  NOTE_TEMPLATES_FILTER_CLEAR,
  NOTE_TEMPLATES_FILTER_SET_ARCHIVED,
  NOTE_TEMPLATES_FILTER_SET_CATEGORIES,
  NOTE_TEMPLATES_FILTER_SET_FOR_AGENTS,
  NOTE_TEMPLATES_FILTER_SET_FOR_STUDENTS,
  NOTE_TEMPLATES_FILTER_SET_HIDDEN,
  NOTE_TEMPLATES_FILTER_SET_RESTRICTED,
  NOTE_TEMPLATES_FILTER_SET_SEARCH,
  NOTE_TEMPLATES_FILTER_SET_TAGS,
  NOTE_TEMPLATES_FILTER_SET_TEMPLATE_TYPES,
  NOTE_TEMPLATES_FILTER_SET_VISIBILITY,
  NOTE_TEMPLATES_FILTER_SET_VISIBLE,
  NOTE_TEMPLATES_FILTER_TOGGLE,
  SET_NOTE_TEMPLATES,
  SET_NOTE_TEMPLATES_CATEGORIES_LOADING,
  SET_NOTE_TEMPLATE_CATEGORIES,
  SET_NOTE_TEMPLATE_VARIABLES,
  SET_RENDERED_NOTE_TEMPLATE_ERROR,
  SET_RENDERED_NOTE_TEMPLATE_IS_LOADING,
  SET_RENDERED_NOTE_TEMPLATE_RECEIVED,
} from '../actions/note_templates';

// import { DEFAULT_TEMPLATE_TYPE } from '../../components/NoteTemplates/consts';
const DEFAULT_TEMPLATE_TYPE = 'admin';

export type INoteTemplateState = {
  isLoaded: boolean;
  isLoading: boolean;
  templates: any;
  categories: Array<any>;
  variables: Array<any>;
  rendered_template_is_loading: boolean;
  rendered_template_error: boolean;
  rendered_template_id: void | number | string;
  rendered_template_application_id: void | number | string;
  rendered_template_response: any;
  filter_visible: boolean;
  filter_search: string;
  filter_categories: Array<any>;
  filter_tags: Array<any>;
  filter_for_agents: boolean;
  filter_for_students: boolean;
  filter_restricted: boolean;
  filter_archived: '' | 'true' | 'false';
  filter_template_types: Array<string>;
  multiple_notes_modal_visible: boolean;
  multiple_notes_selected_template_id: void | number | string;
  multiple_notes_selected_note: null;
  multiple_notes_application_ids: Array<any>;
};

const defaultState: INoteTemplateState = {
  isLoaded: false,
  isLoading: false,
  templates: {},
  categories: [],
  variables: [],
  rendered_template_is_loading: false,
  rendered_template_error: false,
  rendered_template_id: null,
  rendered_template_application_id: null,
  rendered_template_response: null,
  filter_visible: false,
  filter_search: '',
  filter_categories: [],
  filter_tags: [],
  filter_for_agents: false,
  filter_for_students: false,
  filter_restricted: false,
  filter_archived: 'false',
  filter_template_types: [DEFAULT_TEMPLATE_TYPE],
  multiple_notes_modal_visible: false,
  multiple_notes_selected_template_id: null,
  multiple_notes_selected_note: null,
  multiple_notes_application_ids: [],
};

const reducer = (state = defaultState, action): INoteTemplateState => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case SET_NOTE_TEMPLATES:
      return {
        ...state,
        templates: action.value,
        isLoaded: true,
        isLoading: false,
      };

    case SET_NOTE_TEMPLATES_CATEGORIES_LOADING:
      if (state.isLoading === action.value) return state;
      return {
        ...state,
        isLoading: action.value,
      };

    case SET_NOTE_TEMPLATE_CATEGORIES:
      return {
        ...state,
        categories: action.value,
      };

    case SET_NOTE_TEMPLATE_VARIABLES:
      return {
        ...state,
        variables: action.value,
      };

    case SET_RENDERED_NOTE_TEMPLATE_IS_LOADING:
      return {
        ...state,
        rendered_template_is_loading: true,
        rendered_template_id: action.template_id,
        rendered_template_application_id: action.application_id,
        rendered_template_response: null,
        rendered_template_error: false,
      };

    case SET_RENDERED_NOTE_TEMPLATE_RECEIVED:
      if (
        action.template_id !== state.rendered_template_id ||
        action.application_id !== state.rendered_template_application_id
      )
        return state;
      return {
        ...state,
        rendered_template_is_loading: false,
        rendered_template_response: action.value,
        rendered_template_error: false,
      };

    case SET_RENDERED_NOTE_TEMPLATE_ERROR:
      if (
        action.template_id !== state.rendered_template_id ||
        action.application_id !== state.rendered_template_application_id
      )
        return state;
      return {
        ...state,
        rendered_template_is_loading: false,
        rendered_template_response: action.value,
        rendered_template_error: true,
      };

    case NOTE_TEMPLATES_FILTER_SET_VISIBILITY:
      if (state.filter_visible !== !!action.value) break;
      return {
        ...state,
        filter_visible: !!action.value,
      };

    case NOTE_TEMPLATES_FILTER_SET_VISIBLE:
      if (state.filter_visible) break;
      return {
        ...state,
        filter_visible: true,
      };

    case NOTE_TEMPLATES_FILTER_SET_HIDDEN:
      if (!state.filter_visible) break;
      return {
        ...state,
        filter_visible: false,
      };

    case NOTE_TEMPLATES_FILTER_TOGGLE:
      return {
        ...state,
        filter_visible: !state.filter_visible,
      };

    case NOTE_TEMPLATES_FILTER_SET_SEARCH:
      return {
        ...state,
        filter_search: action.value,
      };

    case NOTE_TEMPLATES_FILTER_SET_CATEGORIES:
      return {
        ...state,
        filter_categories: action.value,
      };

    case NOTE_TEMPLATES_FILTER_SET_TAGS:
      return {
        ...state,
        filter_tags: action.value,
      };

    case NOTE_TEMPLATES_FILTER_SET_TEMPLATE_TYPES:
      return {
        ...state,
        filter_template_types: action.value,
      };

    case NOTE_TEMPLATES_FILTER_CLEAR:
      return {
        ...state,
        filter_search: '',
        filter_categories: [],
        filter_tags: [],
      };

    case NOTE_TEMPLATES_FILTER_SET_FOR_AGENTS:
      return {
        ...state,
        filter_for_agents: action.value,
      };

    case NOTE_TEMPLATES_FILTER_SET_FOR_STUDENTS:
      return {
        ...state,
        filter_for_students: action.value,
      };

    case NOTE_TEMPLATES_FILTER_SET_RESTRICTED:
      return {
        ...state,
        filter_restricted: action.value,
      };

    case MULTIPLE_NOTES_SHOW:
      if (state.multiple_notes_modal_visible) break;
      return {
        ...state,
        multiple_notes_modal_visible: true,
      };

    case MULTIPLE_NOTES_HIDE:
      if (!state.multiple_notes_modal_visible) break;
      return {
        ...state,
        multiple_notes_modal_visible: false,
      };

    case MULTIPLE_NOTES_SET_VISIBLE:
      if (state.multiple_notes_modal_visible === action.value) break;
      return {
        ...state,
        multiple_notes_modal_visible: action.value,
      };

    case MULTIPLE_NOTES_SET_NOTE:
      if (state.multiple_notes_selected_note === action.value) break;
      return {
        ...state,
        multiple_notes_selected_template_id: null,
        multiple_notes_selected_note: action.value,
      };

    case MULTIPLE_NOTES_UNSET_NOTE:
      if (state.multiple_notes_selected_note === action.value) break;
      return {
        ...state,
        multiple_notes_selected_note: null,
      };

    case MULTIPLE_NOTES_SET_TEMPLATE_ID:
      if (state.multiple_notes_selected_template_id === action.value) break;
      return {
        ...state,
        multiple_notes_selected_note: null,
        multiple_notes_selected_template_id: action.value,
      };

    case MULTIPLE_NOTES_UNSET_TEMPLATE_ID:
      if (state.multiple_notes_selected_template_id === null) break;
      return {
        ...state,
        multiple_notes_selected_template_id: null,
      };

    case MULTIPLE_NOTES_SET_APPLICATION_IDS:
      return {
        ...state,
        multiple_notes_application_ids: action.value,
      };

    case MULTIPLE_NOTES_ADD_APPLICATION_ID:
      if (state.multiple_notes_application_ids.indexOf(action.value) >= 0) break;
      return {
        ...state,
        multiple_notes_application_ids: state.multiple_notes_application_ids.concat(action.value),
      };

    case MULTIPLE_NOTES_REMOVE_APPLICATION_ID:
      if (state.multiple_notes_application_ids.indexOf(action.value) < 0) break;
      return {
        ...state,
        multiple_notes_application_ids: state.multiple_notes_application_ids.filter(
          e => e !== action.value,
        ),
      };

    case MULTIPLE_NOTES_CLEAR_APPLICATION_IDS:
      if (state.multiple_notes_application_ids.length <= 0) break;
      return {
        ...state,
        multiple_notes_application_ids: [],
      };

    case NOTE_TEMPLATES_FILTER_SET_ARCHIVED:
      if (state.filter_archived === action.value) break;
      return {
        ...state,
        filter_archived: action.value,
      };
  }

  return state;
};

export default reducer;
